import "./index.css";
import React from "react";
import EyeIcon from "../EyeIcon";
import EditIcon from "../../../../assets/media/chatsuite/write.png";

export default function Dropdown({
  toggleStatus,
  onEditPortfolio,
  isPublic,
  isOpen,
}) {
  return (
    <ul
      className={`portfolio-card__dropdown ${
        isOpen ? "portfolio-card__dropdown--open" : ""
      }`}
    >
      <li className="portfolio-card__dropdown-item" onClick={onEditPortfolio}>
        <img
          src={EditIcon}
          alt="edit icon"
          className="portfolio-card__dropdown-icon"
        />
        Edit
      </li>
      <li className="portfolio-card__dropdown-item" onClick={toggleStatus}>
        <EyeIcon isPublic={!isPublic} fill="#595959" />
        {` Set to ${isPublic ? "private" : "public"}`}
      </li>
    </ul>
  );
}



// WEBPACK FOOTER //
// ./src/screens/ProductPortfolio/components/Dropdown/index.js